import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDcBcMcHCc_0hfEiduIq2FgH1eVa6CR5m0",
  authDomain: "archxai-portal.firebaseapp.com",
  projectId: "archxai-portal",
  storageBucket: "archxai-portal.firebasestorage.app",
  messagingSenderId: "758453419640",
  appId: "1:758453419640:web:9883efa13257f4975fb78d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
